export default async ({ app }) => {
  try {
    const ruLocale = await app.$axios(`/upload/locale/ru.txt?v=${Math.random()}`)

    if (ruLocale.data) {
      app.i18n.setLocaleMessage('ru', ruLocale.data)
    }
  } catch (e) {

  }

  try {
    const enLocale = await app.$axios(`/upload/locale/en.txt?v=${Math.random()}`)

    if (enLocale.data) {
      app.i18n.setLocaleMessage('en', enLocale.data)
    }
  } catch (e) {

  }
}
